export const SITE_ORIGIN = 'https://burok.app';

export type Translated<T = string> = { fr: T; en: T };

export const DEFAULT_SEO = {
  title: {
    fr: 'Burok — Super App e‑commerce',
    en: 'Burok — e‑commerce Super App',
  },
  description: {
    fr: "Burok est une Super App e‑commerce qui simplifie vos achats, paiements et services au quotidien. Découvrez l'écosystème Burok.",
    en: 'Burok is an e‑commerce Super App that simplifies shopping, payments, and everyday services. Discover the Burok ecosystem.',
  },
  canonicalPath: { fr: '/', en: '/en' },
  ogImagePath: '/assets/BurokBanner.png',
  twitterCard: 'summary_large_image' as const,
};

export type SeoInput = {
  title?: string | Translated<string>;
  description?: string | Translated<string>;
  canonicalPath?: string | Translated<string>;
  ogImagePath?: string;
  noindex?: boolean;
};
